'use strict'

var Marionette = require('marionette')
var App = require('app')
var PageComponent = require('src/components/page-view')

/**
 * Header layout
 * -----------------------------------------------------------------------------
 */
var HeaderDetails = Marionette.View.extend({
  template: require('./templates/headerDetails.html'),
  modelEvents: {
    'change': 'render'
  },
  templateContext: function () {
    return {
      getConditionalStr: App.TemplateHelpers.getConditionalStr,
      getDeviceTypeLabel: App.TemplateHelpers.getDeviceTypeLabel,
      userHasRole: App.TemplateHelpers.userHasRole
    }
  }
})
module.exports.HeaderDetails = HeaderDetails

/**
 * Page layout
 * -----------------------------------------------------------------------------
 */
var Layout = PageComponent.Layout.extend({
  className: 'page page-device'
})

module.exports.Layout = Layout



// WEBPACK FOOTER //
// ./js/modules/devices/show/view.js